export default "https://assets.egbcdn.net/assets/packs/_/images/app/app-gif-eng-bc86cd5fe48bad07bef76c412f0ae3a8.gif";